import React, { useState } from 'react';
import { Crown, Settings, Bell, Search } from '../utils/icons';
import ThemeToggle from './ThemeToggle';
import ConnectionStatusIndicator from './ConnectionStatusIndicator';
import SettingsPanel from './SettingsPanel';

const EnhancedHeader: React.FC = () => {
  const [isSettingsOpen, setIsSettingsOpen] = useState(false);

  return (
    <>
      <header
      className="
        bg-white dark:bg-gray-900 
        border-b border-gray-200 dark:border-gray-800
        transition-colors duration-300
        animate-fade-in-down
      "
    >
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex items-center justify-between h-16">
          {/* Logo and Title */}
          <div 
            className="flex items-center space-x-3 transition-transform hover:scale-105"
          >
            <div
              className="text-primary-600 dark:text-primary-400"
            >
              <Crown className="h-8 w-8" />
            </div>
            <div>
              <h1 className="text-xl font-bold text-gray-900 dark:text-white">
                Universal Crown Prime
              </h1>
              <p className="text-xs text-gray-500 dark:text-gray-400">
                Project Setup System
              </p>
            </div>
          </div>

          {/* Search Bar */}
          <div className="hidden md:flex flex-1 max-w-md mx-8">
            <div className="relative w-full">
              <div className="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none">
                <Search className="h-4 w-4 text-gray-400" />
              </div>
              <input
                type="text"
                placeholder="Search projects, tools, recommendations..."
                className="
                  block w-full pl-10 pr-4 py-2 text-sm
                  bg-gray-50 dark:bg-gray-800
                  border border-gray-300 dark:border-gray-600
                  rounded-lg
                  focus:ring-2 focus:ring-primary-500 focus:border-transparent
                  dark:text-white dark:placeholder-gray-400
                  transition-colors duration-200
                "
              />
            </div>
          </div>

          {/* Right side controls */}
          <div className="flex items-center space-x-4">
            {/* Connection Status */}
            <ConnectionStatusIndicator />

            {/* Notifications */}
            <button
              aria-label="Open notifications"
              title="Notifications"
              className="
                relative p-2 rounded-lg
                text-gray-600 dark:text-gray-400
                hover:bg-gray-100 dark:hover:bg-gray-800
                transition duration-200 transform hover:scale-105 active:scale-95
              "
            >
              <Bell className="h-5 w-5" />
              {/* Notification badge */}
              <div
                className="
                  absolute -top-1 -right-1
                  h-3 w-3 bg-red-500 rounded-full
                  flex items-center justify-center
                  animate-fade-in
                "
              >
                <span className="text-xs text-white font-bold">3</span>
              </div>
            </button>

            {/* Theme Toggle */}
            <ThemeToggle />

            {/* Settings */}
            <button
              onClick={() => setIsSettingsOpen(true)}
              className="
                p-2 rounded-lg
                text-gray-600 dark:text-gray-400
                hover:bg-gray-100 dark:hover:bg-gray-800
                transition duration-200 transform hover:scale-105 active:scale-95
              "
              aria-label="Open settings"
              title="Open settings"
            >
              <Settings className="h-5 w-5" />
            </button>
          </div>
        </div>
      </div>

      {/* Progress indicator for ongoing operations */}
      <div
        className="h-1 bg-gradient-to-r from-primary-500 to-purple-500 transform origin-left hidden"
      />
    </header>

    {/* Settings Panel */}
    <SettingsPanel 
      isOpen={isSettingsOpen} 
      onClose={() => setIsSettingsOpen(false)} 
    />
  </>
  );
};

export default EnhancedHeader;
